import RecipePreviewComponent from "./RecipePreviewComponent";

export default RecipePreviewComponent;